let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7reOr")).then(() => parcelRequire('g7lF5'));